import IcMoreVert from './IcMoreVert'

export default IcMoreVert
